export const handlePhoneMask = (phone) => {
    const onlyNumbers = (value) => value.replace(/\D/g, "");
    const phoneToShow = onlyNumbers(phone);
    if(phoneToShow.length === 11 ) {
        return `${phoneToShow[2]}${phoneToShow[3]}******${phoneToShow[phoneToShow.length -2]}${phoneToShow[phoneToShow.length -1]}`;
    }
    return `${phoneToShow[0]}${phoneToShow[1]}******${phoneToShow[phoneToShow.length -2]}${phoneToShow[phoneToShow.length -1]}`;
}